import * as o from "react";
import e from "../lib/IconBase.es.js";
import s from "../defs/Binoculars.es.js";
const r = o.forwardRef((a, c) => /* @__PURE__ */ o.createElement(e, { ref: c, ...a, weights: s }));
r.displayName = "BinocularsIcon";
const i = r;
export {
  i as Binoculars,
  r as BinocularsIcon
};
